import classNames from 'classnames'
import styles from '../Navigation.module.scss'
import { Link, useLocation } from 'react-router'
import { memo } from 'react'
import { NavigationItemProps } from '../types.ts'
import NavigationItemContent from '../navigation-item-content/NavigationItemContent.tsx'

const NavigationItem = memo(
  ({ extraActiveRoutes, url, onClick, isMore, isActive, id, activeIcon, overrideInactive, ...contentProps }: NavigationItemProps) => {
    // React Router
    const { pathname } = useLocation()

    // Constants
    const isActiveItem = url
      ? !overrideInactive?.some((route) => pathname.includes(route)) &&
        (pathname.includes(url) || extraActiveRoutes?.some((route) => pathname.includes(route)))
      : isActive
    const icon = isActiveItem && !!activeIcon ? activeIcon : contentProps.icon

    return (
      <li className={styles['navigation-item']}>
        {url ? (
          <Link
            to={url}
            className={classNames(styles.item, {
              [styles.more]: isMore,
              [styles.selected]: isActiveItem
            })}
            onClick={onClick}
            title={contentProps.collapsed ? contentProps.text : undefined}
          >
            <NavigationItemContent {...contentProps} {...{ isMore, icon }} iconClass={styles.icon} />
          </Link>
        ) : (
          <button
            className={classNames(styles.item, {
              [styles.more]: isMore,
              [styles.selected]: isActiveItem
            })}
            onClick={() => {
              onClick?.()
            }}
            title={contentProps.collapsed ? contentProps.text : undefined}
          >
            <NavigationItemContent {...contentProps} {...{ isMore, icon }} iconClass={styles.icon} />
          </button>
        )}
      </li>
    )
  }
)

NavigationItem.displayName = 'SidebarItem'

export default NavigationItem
